import getClient from "./ApiClient";

export async function logout() {
	const client = await getClient();

	try {
		// Directus SDK exposes auth.logout on the client
		// guard in case the SDK shape differs
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		// if (client && client.auth && typeof client.auth.logout === "function") {
		// 	// @ts-ignore
		// 	await client.auth.logout();
		// }
        client.logout();
        console.debug("Logout successful");
	} catch (error) {
		console.error("Error during logout:", error);
		throw error;
	}
}
